
(function (angular, window) {
    'use strict';

    angular
       .module('SMART2')
       .service('persistenceService', ['APPCONSTANTS', '$timeout', 'PLATFORMURLs', 'persistenceApiService', 'sectionsPersistenceService', 'nPlusOneService' , persistenceServiceFunc])
       .factory('persistenceApiService', ['APPCONSTANTS', '$timeout', 'PLATFORMURLs', 'httpService', '$http', '$window', '$filter', persistenceApiServiceFunc])
       .service('sectionsPersistenceService', ['APPCONSTANTS', '$timeout', 'PLATFORMURLs', 'persistenceApiService', sectionsPersistenceServiceFunc])
       .service('nPlusOneService', ['APPCONSTANTS', '$window','$timeout', 'PLATFORMURLs', 'persistenceApiService', '$state', nPlusOneServiceFunc])


    function persistenceServiceFunc(APPCONSTANTS, $timeout, PLATFORMURLs, persistenceApiService, sectionsPersistenceService, nPlusOneService) {

        var _api = persistenceApiService;
        var _sectionPersistence = sectionsPersistenceService;
        var _nPlusOne = nPlusOneService;
        var _userData = {};
        var _state = ''
        var _documentType = ''
 

        function redirectToPreviousNode(redirectToWorkspace, customUrl) {
            _nPlusOne.redirectToPreviousNode(redirectToWorkspace, customUrl);
        }
        function getUserData(docType) {
            if (typeof _userData == 'object' && typeof _userData.length == 'undefined') {
                angular.extend(_userData, _api.getUserData(_api.storeLocation.DB, docType));
            }
        }

        function updateUserData(key, value) {
            if (_userData == undefined) {
                _userData = {};
            }
            _userData[key] = value;
        }
        function getModelData(newConfig, modelData, unbindModelDataWatcher, initChipsWatcher) {
            if (typeof newConfig.documentType != 'undefined') {
                _documentType = newConfig.documentType;
                _nPlusOne.getModelData(_documentType, modelData, unbindModelDataWatcher, initChipsWatcher)
            }
        }

        function saveRecentDocument(newVal, modelData) {
            _nPlusOne.saveRecentDocument(newVal, modelData);
        }

        function saveWorkspaceRecentDocument(newVal) {
            _nPlusOne.saveWorkspaceRecentDocument(newVal);
        }

        function saveUserData(docType) {
            if (typeof _userData == 'object' && typeof _userData.length == 'undefined') {
                _api.saveUserData(_api.storeLocation.DB, docType, null, _userData);
            }
        }






        var service = {
            userData: _userData,
            api: _api,
            sectionPersistence: _sectionPersistence,
            nPlusOne: _nPlusOne,
            getUserData: getUserData,
            updateUserData: updateUserData,
            saveUserData: saveUserData,
            redirectToPreviousNode: redirectToPreviousNode,
            getModelData: getModelData,
            saveRecentDocument: saveRecentDocument,
            saveWorkspaceRecentDocument: saveWorkspaceRecentDocument

        }
        return service;
    }

    function persistenceApiServiceFunc(APPCONSTANTS, $timeout, PLATFORMURLs, httpService, $http, $window, $filter) {

        var _userData = {};
        var _StoreLocation = {
            "DB": 1,
            "LocalStorage": 2,
            "SessionStorage": 3,
            "IndexDB": 4
        };






        function _getUserDataFromLocalStorage(key) {

            if (typeof localStorage[key] != 'undefined' && localStorage[key] != '') {
                return localStorage[key];
            }
            return null;
        };

        function _getUserDataFromSessionStorage(key) {

            if (typeof sessionStorage[key] != 'undefined' && sessionStorage[key] != '') {
                return sessionStorage[key];
            }
            return null;
        };

        function _getUserDataFromIndexDBStorage(key) {

            if (typeof indexedDB[key] != 'undefined' && indexedDB[key] != '') {
                return indexedDB[key];
            }
            return null;
        };

        function _getUserDataFromDB(docType) {
            var postData = {
                "contactCode": APPCONSTANTS.userPreferences.UserBasicDetails.ContactCode,
                "partnerCode": APPCONSTANTS.userPreferences.UserBasicDetails.BuyerPartnerCode,
                "documentType": docType
            };


            $.ajax({
                url: APPCONSTANTS.userPreferences.URLs.AppURL+'/getSmartActions?oloc=' + APPCONSTANTS.oloc.Persistence + "&c=" + APPCONSTANTS.userPreferences.EncryptedBPC,
                method: "POST",
                async: false,
                dataType: 'json',
                timeout: 3000,
                data: JSON.stringify(postData),
                contentType: "application/json",
                success: function (data) {
                    if (data) {
                        if (data.length > 0) {
                            while (typeof data == 'string') {
                                data = JSON.parse(data);
                            }
                        }
                        if (typeof data[0] != 'undefined') {
                            if (typeof data[0]['events'] != 'undefined') {
                                while (typeof data[0]['events'] == 'string') {
                                    data[0]['events'] = JSON.parse(data[0]['events']);
                                }
                                _userData = data[0]['events'];
                            }
                        }
                        if (typeof data.msg != 'undefined') {
                            sessionStorage.isConfigOff = true;
                        }

                    }
                    //userData={};
                },
                error: function (err) {
                    //return null;
                }
            });
        }



        function _setUserDataInLocalStorage(key, value) {
            if (key != null && key != '') {
                localStorage[key] = value;
            }
        };

        function _setUserDataInSessionStorage(key, value) {
            if (key != null && key != '') {
                sessionStorage[key] = value;
            }
        };

        function _setUserDataInIndexDBStorage(key, value) {
            if (key != null && key != '') {
                indexedDB[key] = value;
            }
        };

        function _saveUserDataInDB(docType, userData, documentType) {
            var request = {};
            if (typeof documentType == 'undefined') {
                documentType = docType;
            }

            var postData = {
                "contactCode": APPCONSTANTS.userPreferences.UserBasicDetails.ContactCode,
                "partnerCode": APPCONSTANTS.userPreferences.UserBasicDetails.BuyerPartnerCode,
                "documentType": documentType,
                "events": JSON.stringify(userData)
            };
            request.data = angular.toJson(postData);
            $.ajax({
                url: APPCONSTANTS.userPreferences.URLs.AppURL + '/saveSmartActions?oloc=' + APPCONSTANTS.oloc.Persistence+"&c=" + APPCONSTANTS.userPreferences.EncryptedBPC,
                method: "POST",
                async: true,
                dataType: 'json',
                data: JSON.stringify(postData),
                contentType: "application/json",
                success: function (data) {
                }
            });
        }

        function _getUserData(storeLocation, docType, key) {
            if (storeLocation == 1) {
                _getUserDataFromDB(docType);
                return _userData;
            }
            else if (storeLocation == 2) {
                return _getUserDataFromLocalStorage(key);
            }
            else if (storeLocation == 3) {
                return _getUserDataFromSessionStorage(key);
            }
            else if (storeLocation == 4) {
                return _getUserDataFromIndexDBStorage(key);
            }
        };

        function _saveUserData(storeLocation, docType, key, value, documentType) {
            if (storeLocation == 1) {
                _saveUserDataInDB(docType, value, documentType);
            }
            else if (storeLocation == 2) {
                _setUserDataInLocalStorage(key, value);
            }
            else if (storeLocation == 3) {
                _setUserDataInSessionStorage(key, value);
            }
            else if (storeLocation == 4) {
                _setUserDataInIndexDBStorage(key, value);
            }
        };

        var service = {
            storeLocation: _StoreLocation,
            getUserData: _getUserData,
            saveUserData: _saveUserData,
            userData: _userData
        }
        return service;
    }

    function sectionsPersistenceServiceFunc(APPCONSTANTS, $timeout, PLATFORMURLs, persistenceApiService) {

        var _userData = {};


        function _getSections(jsonObj) {
            try {
                if (typeof jsonObj['sections'] != 'undefined') {
                    return jsonObj['sections'];
                }
                return [];
            } catch (err) { }
            return [];
        }

        function _setState(key, value) {
            if (typeof _userData[0] == 'undefined') {
                _userData = {};
            }
            _state = key;
            _userData[key] = value;
        }

        function _setUserData(key, value) {
            try {
                if (_state != '') {
                    _userData[_state][key] = value;
                } else {
                    _userData[key] = value;
                }

            } catch (err) { }
            // return [];
        }

        function getSectionsPersistence(formConfig, userData) {
            if (formConfig && typeof formConfig.documentType != 'undefined') {
                //persistenceService.getUserData(formConfig.documentType);
                var usersSections = _getSections(userData);
                if (usersSections) {
                    if (usersSections.length > 0) {
                        var sIndex = 100;
                        angular.forEach(formConfig.sections, function (section) {
                            if (typeof section.id != 'undefined') {
                                for (var i = 0; i < usersSections.length; i++) {
                                    var sectionId = usersSections[i];
                                    if (APPCONSTANTS.userPreferences.DocumentTypeId == 8) {
                                        sectionId = getOrderSectionId(usersSections[i]);
                                    }
                                    if (section.id == sectionId) {
                                        section.sectionIndex = i;
                                        break;
                                    }
                                }
                            }
                            else {
                                sIndex++;
                                section.sectionIndex = sIndex;
                            }
                        });
                        formConfig.sections = _.sortBy(formConfig.sections, 'sectionIndex');
                    }
                }
            }
        };

        //Added for Order 2.0, NG5 Sections Persistence 
        function getOrderSectionId(sectionId) {
            if (sectionId) {
                switch (sectionId) {
                    case 'BasicDetails':
                        return 'BasicDetails';
                    case 'SupplierDetails':
                        return 'SupplierDetails';
                    case 'InvoicingAndDeliveryDetails':
                    case 'InvoicingDelivery':
                        return 'InvoicingAndDeliveryDetails';
                    case 'AdditionalInformation':
                    case 'CustomAttributes':
                        return 'AdditionalInformation';
                    case 'InvoicingMatchingTolerance':
                    case 'ToleranceDetails':
                        return 'InvoicingMatchingTolerance';
                    case 'TermsAndCondition':
                    case 'TermsAndConditions':
                        return 'TermsAndCondition';
                    case 'IncoTerms':
                        return 'IncoTerms';
                    case 'ReceivingTolerance':
                        return 'ReceivingTolerance';
                    case 'NotesAndAttachments':
                        return 'NotesAndAttachments';
                    case 'Notification_caps':
                    case 'Notification':
                        return 'Notification_caps';
                    case 'TeamMember_caps':
                    case 'TeamMembers':
                        return 'TeamMember_caps';
                    case 'LineDetails':
                        return 'LineDetails';
                    default:
                        return sectionId;
                }
            }
            return '';
        }

        var service = {
            getSectionsPersistence: getSectionsPersistence,

            setState: _setState,
            setUserData: _setUserData
        }
        return service;
    }

    function nPlusOneServiceFunc(APPCONSTANTS, $window, $timeout, PLATFORMURLs, persistenceApiService, $state) {
        var newDocFlag = false;
        var docDetailsTemplate = {};
        var docDetails = {};
        var dirtyCheck = [];
        var docType = -10;
        var selectedSectionId = '';
        var states = ['/rfx/edit/:id', '/supplier/scorecard', '/supplier/form', '/contract/:id','/supplier/profile'];
        function _redirectToPreviousNode(redirectToWorkspace, customUrl) {
            var goHistoryMinus1=false;
            if ($state.current.url.indexOf('rfx') > -1 ||
				$state.current.url.indexOf('scorecard') > -1 ||
				$state.current.url.indexOf('form') > -1) {
                if (states.indexOf($state.current.url) > -1) {
                    goHistoryMinus1=false;
                }
                else{
                    goHistoryMinus1=true;
                }
            }

            if (typeof customUrl != 'undefined' && customUrl != null) {
                window.location.href = customUrl;
                return;
            }  

            if(!goHistoryMinus1){
                if (!_historyIsEmpty()) {
                    if (typeof sessionStorage.workspace2_Enabled != "undefined") {
                        if (sessionStorage.workspace2_Enabled == true || sessionStorage.workspace2_Enabled == 'true') {
                            var recDocs = persistenceApiService.getUserData(persistenceApiService.storeLocation.SessionStorage, '', 'recentDocuments');
                            if (typeof recDocs != 'undefined' && recDocs != null && recDocs != 'undefined') {
                                if (typeof recDocs == 'string') {
                                    recDocs = JSON.parse(recDocs)
                                    if (recDocs.length == 0) {
                                        recDocs = [];
                                    }
                                }
                            }
                            if (recDocs.length > 1) {
                                if (recDocs.length > 2) {
                                    if ((recDocs[recDocs.length - 1].hasOwnProperty('docType')) && (recDocs[recDocs.length - 1].docType == 1 || recDocs[recDocs.length - 1].docType == 5 || recDocs[recDocs.length - 1].docType == 6)) {
                                        if ((recDocs[recDocs.length - 2].hasOwnProperty('docType')) && (recDocs[recDocs.length - 2].hasOwnProperty('docCode'))) {
                                            if ((recDocs[recDocs.length - 2].docType == -9) && (recDocs[recDocs.length - 2].docCode.search("landingmax") != -1) && (recDocs[recDocs.length - 2].docCode.search("template") != -1)) {
                                                if ((recDocs[recDocs.length - 3].hasOwnProperty('docType')) && (recDocs[recDocs.length - 3].docType == 21)) {
                                                    var prevDoc = recDocs[recDocs.length - 3];
                                                    recDocs.splice(recDocs.length - 2, 2);
                                                    sessionStorage.recentDocuments = JSON.stringify(recDocs);
                                                    if (typeof customUrl != 'undefined') {
                                                        window.location.href = customUrl;
                                                    }
                                                    else {
                                                        if (prevDoc.hasOwnProperty('urlFormat') && prevDoc.urlFormat == "") {
                                                            //recDocs.splice(recDocs.length - 2, 2);
                                                            //sessionStorage.recentDocuments = JSON.stringify(recDocs);
                                                            history.go(-1);
                                                        }
                                                        else {
                                                            window.location.href = buildUrl(prevDoc);
                                                        }

                                                    }
                                                    return;
                                                }
                                            }

                                        }
                                    }

                                }        

                                var prevDoc = recDocs[recDocs.length - 2];
				if(window.location.pathname.split("/")[1]=="Contract" && recDocs[recDocs.length - 1].docType==-9){
					 prevDoc = recDocs[recDocs.length - 1];
				}
                                if (window.location.pathname == '/PPST/Project/Index' || window.location.href.indexOf('/ppst/create?isFlip=true') > -1) {
                                    history.go(-1);
                                }
                                else if (prevDoc.hasOwnProperty('urlFormat') && prevDoc.urlFormat != "" && prevDoc.urlFormat.indexOf('PPST/QuickCreate/QuickCreateProject') > -1) {
                                    prevDoc = recDocs[recDocs.length - 3];
                                    recDocs.splice(recDocs.length - 2, 2);
                                    sessionStorage.recentDocuments = JSON.stringify(recDocs);
                                    window.location.href = buildUrl(prevDoc);
                                }
                                else {
                                    recDocs.splice(recDocs.length - 1, 1);
                                    sessionStorage.recentDocuments = JSON.stringify(recDocs);

                                    if (typeof customUrl != 'undefined') {
                                        window.location.href = customUrl;
                                    }
                                    else {
                                        if (prevDoc.hasOwnProperty('urlFormat') && prevDoc.urlFormat == "") {

                                            recDocs.splice(recDocs.length - 1, 1);
                                            sessionStorage.recentDocuments = JSON.stringify(recDocs);
                                            history.go(-1);
                                        } else if(prevDoc.hasOwnProperty('urlFormat') && prevDoc.hasOwnProperty('isSCMURL')) {										
                                            sessionStorage.recentDocuments = JSON.stringify(recDocs);
											if(APPCONSTANTS.userPreferences && APPCONSTANTS.userPreferences.IsSCMUser){
												window.location.href = APPCONSTANTS.userPreferences.ScmURL + '/' + prevDoc.urlFormat;
											}
										}
                                        else {
                                            window.location.href = buildUrl(prevDoc);
                                        }


                                    }
                                }
                            }
                        }
                        else { history.go(-1); }
                    }            
                }
                else {
                    if (typeof redirectToWorkspace != 'undefined' && redirectToWorkspace == true) {
                        window.location.href = APPCONSTANTS.appContextUrl;
                    }
                    else if (typeof customUrl != 'undefined') {
                        window.location.href = customUrl;
                    } else if (typeof sessionStorage.workspace2_Enabled != "undefined" && (sessionStorage.workspace2_Enabled == true || sessionStorage.workspace2_Enabled == 'true')) {
						var recentDocs = JSON.parse(sessionStorage.recentDocuments);
						if(recentDocs.length == 1) {
							var currentRedirect = angular.copy(recentDocs[0]);
							recentDocs.splice(recentDocs.length - 1, 1);
                            sessionStorage.recentDocuments = JSON.stringify(recentDocs);
							if(currentRedirect.hasOwnProperty('urlFormat') && currentRedirect.hasOwnProperty('isSCMURL')){
								if(APPCONSTANTS.userPreferences && APPCONSTANTS.userPreferences.IsSCMUser){
									window.location.href =  APPCONSTANTS.userPreferences.ScmURL + '/' + currentRedirect.urlFormat;
								}
							}
						}
					}
                    else {
                        history.go(-1);
                    }
                }        
            }
            else
            {
                history.go(-1);
            }

        
            //var currentURL = $window.location.href;
            //if (currentURL.indexOf('rfx/edit') > -1)
            //    history.go(-2);
            //else
            //    history.go(-1);
        };
        function _historyIsEmpty() {
            if (typeof sessionStorage.recentDocuments != 'undefined' && sessionStorage.recentDocuments != "" && sessionStorage.recentDocuments != null) {
                var recentDocsLength = JSON.parse(sessionStorage.recentDocuments)
                if (history.length >= 1 && recentDocsLength.hasOwnProperty('length') && recentDocsLength.length == 1) {
                    return true;
                }
                else if (history.length > 1 && recentDocsLength.hasOwnProperty('length') && recentDocsLength.length > 1) {
                    return false;
                }
            }
            else {
                if (history.length > 1) {
                    return false;
                }
               
            }
            return true;
        }

        function buildUrl(docDetails) {
            var docUrl = '';
            if (docDetails.docType == -9) {
                docUrl = docDetails.docCode;
            } else
            {
                docUrl = docDetails.urlFormat;
            }
               if (docUrl.search('//') == 0 && docUrl.search('//') != -1) {
                            docUrl = docUrl.replace('//', '/');
                            }
            return docUrl;
        }

        function getDocDataOnChip(documentType) {

            switch (documentType) {
                //RFX
                case 1: docDetails =
                    {
                        "docAttrs": [{ "key": "docName", "value": "setup.EventName" },
                        //{ "key": "docNumber", "value": "" },
                        { "key": "docCode", "value": "setup.DocumentCode" }],
                        "docConditions": { "initialCondition": "" },
                        "bpc": "APPCONSTANTS.userPreferences.UserBasicDetails.BuyerPartnerCode",
                        "dd": "dc={docCode}&bpc={bpc}",
                        "urlFormat": "/Sourcing/Rfx?oloc=" + APPCONSTANTS.oloc.rfxOloc + "&dd={}"
                        //https://smartqc.gep.com//Sourcing/Rfx?oloc=216&dd=ZGM9MTc3NTImYnBjPTQ0MzUxNQ2 
                    };
                    return docDetails;
                // Sourcing Request
                case 66: docDetails =
                {
                    "docAttrs": [{ "key": "docName", "value": "setup.EventName" },
                    //{ "key": "docNumber", "value": "" },
                    { "key": "docCode", "value": "setup.DocumentCode" }],
                    "docConditions": { "initialCondition": "" },
                    "bpc": "APPCONSTANTS.userPreferences.UserBasicDetails.BuyerPartnerCode",
                    "dd": "dc={docCode}&bpc={bpc}",
                    "urlFormat": "/Sourcing/SRRfx?oloc=" + APPCONSTANTS.oloc.rfxOloc + "&dd={}" + "&c=" + APPCONSTANTS.userPreferences.EncryptedBPC
                    //https://smartqc.gep.com//Sourcing/Rfx?oloc=216&dd=ZGM9MTc3NTImYnBjPTQ0MzUxNQ2 
                };
                return docDetails;
                //Invoice
                case 9:
                    docDetails =
                        {
                            "docAttrs": [{ "key": "docName", "value": "InvoiceData.name" },
                            { "key": "docNumber", "value": "InvoiceData.number" },
                            { "key": "docCode", "value": "InvoiceData.documentCode" }],
                            "docConditions": { "initialCondition": "typeof modelData.InvoiceData.documentCode != 'undefined' && modelData.InvoiceData.documentCode > 0 && typeof modelData.InvoiceData.number != 'undefined' && modelData.InvoiceData.number != null" },
                            "bpc": "APPCONSTANTS.userPreferences.UserBasicDetails.BuyerPartnerCode",
                            "dd": "dc={docCode}&bpc={bpc}&st=15",
                            "urlFormat": "/P2P/Invoice?dd={}&oloc=" + APPCONSTANTS.oloc.invoiceOloc + "#/invoice"

                        };
                    return docDetails;

                //Order
                case 8:
                    docDetails =
                        {
                            "docAttrs": [{ "key": "docName", "value": "orderData.name" },
                            { "key": "docNumber", "value": "orderData.number" },
                            { "key": "docCode", "value": "orderData.documentCode" }],
                            "docConditions": { "initialCondition": "typeof modelData.orderData.documentCode != 'undefined' && modelData.orderData.documentCode > 0 && typeof modelData.orderData.number != 'undefined' && modelData.orderData.number != null" },
                            "bpc": "APPCONSTANTS.userPreferences.UserBasicDetails.BuyerPartnerCode",
                            "dd": "dc={docCode}&bpc={bpc}&st=15",
                            "urlFormat": "/P2P/Order?dd={}&oloc=" + APPCONSTANTS.oloc.orderOloc + "#/po"

                        };
                    return docDetails;

                //Requisition
                case 7:
                    docDetails =
                        {
                            "docAttrs": [{ "key": "docName", "value": "ReqData.name" },
                            { "key": "docNumber", "value": "ReqData.number" },
                            { "key": "docCode", "value": "ReqData.documentCode" }],
                            "docConditions": { "initialCondition": "typeof modelData.ReqData.documentCode!= 'undefined' && typeof modelData.ReqData.number!= 'undefined' && modelData.ReqData.number != '' " },
                            "bpc": "APPCONSTANTS.userPreferences.UserBasicDetails.BuyerPartnerCode",
                            "dd": "dc={docCode}&bpc={bpc}&st=15",
                            "urlFormat": "/P2P/Index?dd={}&oloc=" + APPCONSTANTS.oloc.reqOloc + "#/requisitions/{}"
                            //https://smartdev.gep.com/P2P/Index?dd=ZGM9MCZicGM9Mjg2Mjkmc3Q9MQ2&oloc=216#/requisitions/ZGM9MCZicGM9Mjg2Mjkmc3Q9MQ2
                        };
                    return docDetails;

                //IR
                case 14:
                    docDetails =
                        {
                            "docAttrs": [{ "key": "docName", "value": "IRData.name" },
                            { "key": "docNumber", "value": "IRData.number" },
                            { "key": "docCode", "value": "IRData.documentCode" }],
                            "docConditions": { "initialCondition": "typeof modelData.IRData.documentCode != 'undefined' && modelData.IRData.documentCode > 0" },
                            "bpc": "APPCONSTANTS.userPreferences.UserBasicDetails.BuyerPartnerCode",
                            "dd": "dc={docCode}&bpc={bpc}&st=15",
                            "urlFormat": "/P2P/IR?dd={}&oloc=" + APPCONSTANTS.oloc.irOloc + "#/ir"
                            //https://smartdev.gep.com/P2P/IR?dd=ZGM9MCZicGM9Mjg2Mjkmc3Q9MQ2&oloc=225#/ir
                        };
                    return docDetails;


                ////Receipts
                //case 11:  
                //    docDetails = 
                //        {
                //            "docAttrs": [{ "key": "docName", "value": "" },
                //                         { "key": "docNumber", "value": "" },
                //                         { "key": "docCode", "value": "" }],
                //            "docConditions": { "initialCondition":  }
                //        };
                //    return docDetails;

                //Forms
                case 11:
                    docDetails =
                        {
                            "docAttrs": [{ "key": "docName", "value": "setup.formName" },
                            //{ "key": "docNumber", "value": "" },
                            { "key": "docCode", "value": "$('#hdnFormCode').val()" }],
                            "docConditions": { "initialCondition": "" },
                            "bpc": "APPCONSTANTS.userPreferences.UserBasicDetails.BuyerPartnerCode",
                            "dd": "dc={docCode}&bpc={bpc}&st=15",
                            "urlFormat": "/PartnerManagement/Form/CreateForm?dd={}&oloc=" + APPCONSTANTS.oloc.formOloc
                            //https://smartdev.gep.com/PartnerManagement/Form/CreateForm?dd=ZGM9MCZicGM9Mjg2Mjkmc3Q9MQ2&oloc=105 
                        };
                    return docDetails;

                //Assessment or scorecard
                case 12:
                    docDetails =
                        {
                            "docAttrs": [{ "key": "docName", "value": "setup.name" },
                            // { "key": "docNumber", "value": "" },
                            { "key": "docCode", "value": "$('#hdnAssessmentCode').val()" }],
                            "docConditions": { "initialCondition": "typeof modelData.setup.name != 'undefined' && modelData.setup.name != '' " },
                            "bpc": "APPCONSTANTS.userPreferences.UserBasicDetails.BuyerPartnerCode",
                            "dd": "dc={docCode}&bpc={bpc}&st=15",
                            "urlFormat": "/supplierManagement/Scorecard?dd={}&oloc=" + APPCONSTANTS.oloc.scorcardOloc + "#/supplier/scorecard"
                            //https://smartqc.gep.com/supplierManagement/Scorecard?dd=ZGM9MCZicGM9NDQzNTE1JnN0PTE1&oloc=216#/supplier/scorecard

                        };
                    return docDetails;

                //Partnerprofile
                case 19: docDetails =
                    {
                        "docAttrs": [{ "key": "docName", "value": "partnerDetails.objPartnerDetails.LegalCompanyName" },
                        { "key": "docCode", "value": "partnerDetails.objPartnerDetails.PartnerCode" }],
                        "docConditions": { "initialCondition": "" },
                        "bpc": "APPCONSTANTS.userPreferences.UserBasicDetails.BuyerPartnerCode",
                        "dd": "spc={docCode}&bpc={bpc}",
                        "urlFormat": "/supplierManagement/Profile?dd={}&oloc=" + APPCONSTANTS.oloc.partnerOloc + "#/supplier/profile"
                        // https://smartqc.gep.com/supplierManagement/Profile?dd=c3BjPTUxMjU2MyZicGM9NDQzNTE10&oloc=216#/supplier/profile 
                    };
                    return docDetails;

                //P2P Contract
                case 5: docDetails =
                    {
                        "docAttrs": [{ "key": "docName", "value": "ContractInfo.ContractDetails.DocumentName " },
                        { "key": "docNumber", "value": "ContractInfo.ContractDetails.DocumentNumber" },
                        { "key": "docCode", "value": "ContractInfo.ContractDetails.DocumentCode " }],
                        "docConditions": { "initialCondition": "typeof modelData.ContractInfo.ContractDetails.DocumentCode != 'undefined' &&  modelData.ContractInfo.ContractDetails.DocumentCode > 0 && typeof modelData.ContractInfo.ContractDetails.DocumentNumber != 'undefined' && modelData.ContractInfo.ContractDetails.DocumentNumber != null  && typeof modelData.ContractInfo.ContractDetails.DocumentName != 'undefined' && modelData.ContractInfo.ContractDetails.DocumentName != null" },
                        "bpc": "APPCONSTANTS.userPreferences.UserBasicDetails.BuyerPartnerCode",
                        "dd": "dc={docCode}&bpc={bpc}&st=15",
                        "urlFormat": "/Contract/ContractInfo/Index?oloc=" + APPCONSTANTS.oloc.contractOloc + "&dd={}&dt=5#/contract/new"
                        //https://smartqc.gep.com/Contract/ContractInfo/Index?oloc=104&dd=ZGM9MCZicGM9NDQyMjQ1JnN0PTE1&dt=5#/contract/new  
                    };
                    return docDetails;

                //Catalog 
                //no user
                case 6: docDetails =
                    {
                        "docAttrs": [{ "key": "docName", "value": "" },
                        { "key": "docNumber", "value": "" },
                        { "key": "docCode", "value": "" }],
                        "docConditions": { "initialCondition": "" },
                        "bpc": "APPCONSTANTS.userPreferences.UserBasicDetails.BuyerPartnerCode"
                    };
                    return docDetails;

                //Auction
                //case 6: docDetails = 
                //    {
                //        "docAttrs": [{ "key": "docName", "value": "" },
                //                     { "key": "docNumber", "value": "" },
                //                     { "key": "docCode", "value": "" }],
                //        "docConditions": { "initialCondition":  }
                //    };
                //    return docDetails;

                //Project
                //case 6: docDetails =
                //    {
                //        "docAttrs": [{ "key": "docName", "value": "" },
                //        { "key": "docNumber", "value": "" },
                //        { "key": "docCode", "value": "" }],
                //        "docConditions": { "initialCondition": "" },
                //        "bpc": "",
                //        "urlFormat": "/req/Index?dd={dc={docCode}&bpc={bpc}&st=15}"
                //    };
                //    return docDetails;

                //Project
                case 21:
                    docDetails =
                        {
                            "docAttrs": [{ "key": "docName", "value": "Project.Title" },
                            { "key": "docNumber", "value": "Project.DocumentNumber" },
                            { "key": "docCode", "value": "Project.DocumentCode" }],
                            "docConditions": { "initialCondition": "" },
                            "bpc": "APPCONSTANTS.userPreferences.UserBasicDetails.BuyerPartnerCode",
                            "dd": "dc={docCode}&bpc={bpc}",
                            "urlFormat": "/?dd={}&oloc=" + APPCONSTANTS.oloc.projectOloc+ "&c=" + APPCONSTANTS.userPreferences.EncryptedBPC + "#/ppst/edit?dd={}"
                            //https://smartqc.gep.com/?dd=ZGM9MTc1NzUmYnBjPTQ0MzUxNQ2&oloc=223#/ppst/edit?dd=ZGM9MTc1NzUmYnBjPTQ0MzUxNQ2 
                        };
                    return docDetails;
                case 33:
                    docDetails =
                        {
                            "docAttrs": [{ "key": "docName", "value": "Project.Title" },
                            { "key": "docNumber", "value": "Project.DocumentNumber" },
                            { "key": "docCode", "value": "Project.DocumentCode" }],
                            "docConditions": { "initialCondition": "" },
                            "bpc": "APPCONSTANTS.userPreferences.UserBasicDetails.BuyerPartnerCode",
                            "dd": "dc={docCode}&bpc={bpc}",
                            "urlFormat": "/?dd={}&oloc=" + APPCONSTANTS.oloc.projectOloc + "&c=" + APPCONSTANTS.userPreferences.EncryptedBPC + "#/projectRequest/edit?dd={}"
                            //https://smartqc.gep.com/?dd=ZGM9NDQzNzg5JmJwYz0xODk1MTU1&oloc=223&c=MTg5NTE10#/projectRequest/edit?dd=ZGM9NDQzNzg5JmJwYz0xODk1MTU1
                        };
                    return docDetails;
			     //Procurement Profile
		            case 38:
                    docDetails =
                        {
                            "docAttrs": [{ "key": "docName", "value": "ProcurementProfileData.name" },
                            { "key": "docNumber", "value": "ProcurementProfileData.number" },
                            { "key": "docCode", "value": "ProcurementProfileData.documentCode" }],
                            "docConditions": { "initialCondition": "typeof modelData.ProcurementProfileData.documentCode!= 'undefined' && typeof modelData.ProcurementProfileData.number!= 'undefined' && modelData.ProcurementProfileData.number != '' " },
                            "bpc": "APPCONSTANTS.userPreferences.UserBasicDetails.BuyerPartnerCode",
                            "dd": "dc={docCode}&bpc={bpc}&st=15",
                            "urlFormat": "/P2P/procurementprofile?dd={}&oloc=" + APPCONSTANTS.oloc.procurementProfileOloc + "#/ProcurementProfile"
                            //https://smartdev.gep.com/P2P/procurementprofile?dd=ZGM9NzYzODImYnBjPTcwMDIxNzEx0&oloc=232&c=NzAwMjE3MTE1#/ProcurementProfile
                        };
                    return docDetails;
                case 65:
                    docDetails =
                    {
                        "docAttrs": [{ "key": "docName", "value": "$('#hdnCompanyName').val()" },
                        { "key": "docCode", "value": "SupplierRequestCode" }],
                        "docConditions": { "initialCondition": "" },
                        "bpc": "APPCONSTANTS.userPreferences.UserBasicDetails.BuyerPartnerCode",
                        "dd": "dc={docCode}&bpc={bpc}",
                        "urlFormat": "/supplierManagement/SupplierRequest?dd={}&oloc=" + APPCONSTANTS.oloc.SupplierRequest + "#/supplier/supplierRequest"
                    };
                    return docDetails;
            }

        }

        function getModelData(documentType, modelData, unbindModelDataWatcher, initChipsWatcher) {
            docType = documentType;
            var docDetailsTemplate = {};
            docDetailsTemplate = getDocDataOnChip(documentType);
            var listOfDocData = {};
            var ModelAttrList = [];
            if (typeof docDetailsTemplate != 'undefined' && typeof docDetailsTemplate.docAttrs != 'undefined') {
                docDetailsTemplate.docAttrs.forEach(function (obj) {
                    listOfDocData[obj.key] = "";
                    var modelAttrs = obj.value.split('.');
                    var tempObj;
                    ModelAttrList.push('modelData.' + obj.value)

                });

                if (ModelAttrList.length > 0) {
                    initChipsWatcher(ModelAttrList);
                    unbindModelDataWatcher();
                }
            } else {
                unbindModelDataWatcher();
            }

        }


        function saveRecentDocument(newVal, modelData) {
            console.log(APPCONSTANTS.userPreferences);
            try {
                var enableSave = true;
                var recentDocs = persistenceApiService.getUserData(persistenceApiService.storeLocation.SessionStorage, 0, 'recentDocuments');
                if (typeof recentDocs != 'undefined' && recentDocs != null && recentDocs != 'undefined') {
                    if (typeof recentDocs == 'string') {
                        recentDocs = JSON.parse(recentDocs)
                        if (recentDocs.length == 0) {
                            recentDocs = [];
                        }
                    }
                }
                else {
                    recentDocs = [];
                }
                var lastIndex = recentDocs.length - 1;
                var fromUrl;
                // if (docDetails.docConditions.initialCondition!= "" )
                // {
                //     // try{
                //     //     if(eval(docDetails.docConditions.initialCondition) != true){
                //     //         enableSave=false;
                //     //     }
                //     // }catch(err)
                //     // {
                //     //     console.log(err);
                //     // }

                // }
                if (docDetails.hasOwnProperty('bpc')) {
                    try {
                        docDetails.bpc = eval(docDetails.bpc);
                    } catch (e) {
                        enableSave = false;
                    }
                }

                if (enableSave) {
                    var currentDoc = {};
                    for (var i = 0; i < docDetails.docAttrs.length; i++) {
                        if (docDetails.docAttrs[i].value.indexOf('$') > -1 || docType == 65) {
                            currentDoc[docDetails.docAttrs[i].key] = eval(docDetails.docAttrs[i].value);
                        }
                        else {
                            if (typeof newVal[i] != 'undefined' && newVal[i] != undefined) {
                                currentDoc[docDetails.docAttrs[i].key] = newVal[i];
                            }
                            else
                            {
                                enableSave = false;
                            }
                        }
                    }

                    if (enableSave) {
                        if (currentDoc['docCode'].toString() == '0' || currentDoc['urlFormat'] == "")
                        {
                            newDocFlag = true;
                         }
                        if (docDetails.hasOwnProperty('urlFormat')) {
                            if (docType == 5 && currentDoc['docCode']!= 0) {
                                docDetails.urlFormat = "/Contract/ContractInfo/Index?oloc=" + APPCONSTANTS.oloc.contractOloc + "&dd={}&dt=5#/contract/{}";
                                currentDoc['urlFormat'] = docDetails.urlFormat;

                            }
                            else
                                currentDoc['urlFormat'] = docDetails.urlFormat;

                        }

                        if (docDetails.hasOwnProperty('bpc')) {
                            currentDoc['bpc'] = docDetails.bpc;
                        }

                        if (docDetails.hasOwnProperty('dd')) {
                            currentDoc['dd'] = docDetails.dd;
                        }
                        currentDoc['docType'] = docType;
                        currentDoc['selectedSectionId'] = selectedSectionId;
                        
                        //CF-2067 - "fromUrl" will get add to recentDocs if user's journy starts from Manage or Task, which helps developer to redirect back to perticular page at their end.
                        if(recentDocs.length > 0){
                            if(recentDocs[lastIndex].docType == -9 && (recentDocs[lastIndex].docCode.indexOf("workQueue") > 0 || recentDocs[lastIndex].docCode.indexOf("manage") > 0 || recentDocs[lastIndex].docCode.indexOf("landingmax") > 0)){
                                fromUrl = recentDocs[lastIndex].docCode;
                            }
                            else{
                                fromUrl = recentDocs[lastIndex].hasOwnProperty('fromUrl') ? recentDocs[lastIndex].fromUrl : '';
                            }
    
                            if(currentDoc.docType != -9 && fromUrl){
                                currentDoc['fromUrl'] = fromUrl;
                            }
                        }

                        //Save in localStorage
                        saveRecentDoc(persistenceApiService.storeLocation.LocalStorage, currentDoc);
                        // Save in SessionStorage
                        saveRecentDoc(persistenceApiService.storeLocation.SessionStorage, currentDoc);
                        //Save in DB
                        //saveRecentDoc(persistenceApiService.storeLocation.DB, currentDoc, '-9');
                    }
                }

            } catch (err) {
                console.log(err);
            }
        }


        function saveWorkspaceRecentDocument(newVal) {
            console.log(APPCONSTANTS.userPreferences);
            try {
                var enableSave = true;
              

                if (enableSave) {
                    var currentDoc = {};
                  
                    currentDoc['docName'] = newVal.docName;
                    currentDoc['docCode'] = newVal.docCode ;                  
                    currentDoc['urlFormat'] ='/'+ newVal.urlFormat.replace(APPCONSTANTS.userPreferences.URLs.AppURL, "");
                    if (currentDoc['urlFormat'].search('//') == 0 && currentDoc['urlFormat'].search('//') != -1)
                    {
                        currentDoc['urlFormat'] = currentDoc['urlFormat'].replace('//', '/')
                    }
                    currentDoc['docType'] = newVal.docType;
                    
                    // Save in SessionStorage
                    saveRecentDoc(persistenceApiService.storeLocation.SessionStorage, currentDoc);
                    //Save in DB
                    saveRecentDoc(persistenceApiService.storeLocation.DB, currentDoc, '-9');

                }

            } catch (err) {
                console.log(err);
            }
        }


        function saveRecentDoc(locationStore, currentDoc, documentType) {
            if (locationStore != persistenceApiService.storeLocation.DB) {
                var recentDocsHistoryLength = 10;
                var recentDocs = persistenceApiService.getUserData(locationStore, 0, 'recentDocuments');
                if (typeof recentDocs != 'undefined' && recentDocs != null && recentDocs != 'undefined') {
                    if (typeof recentDocs == 'string') {
                        recentDocs = JSON.parse(recentDocs)
                        if (recentDocs.length == 0) {
                            recentDocs = [];
                        }
                    }
                }
                else {
                    recentDocs = [];
                }
                var lastIndex = recentDocs.length;

                var jObj = {};
                if (typeof currentDoc.dd != 'undefined') {
                    if(currentDoc.docCode == 0){
                        currentDoc.dd = currentDoc.dd.replace("{docCode}", currentDoc.docCode);
                        currentDoc.dd = currentDoc.dd.replace("{bpc}", currentDoc.bpc);
                        var encodedString = encode(currentDoc.dd);
                    }
                    else
                    {
                        var ddVal = window.location.href;
                        ddVal = ddVal.match(/(dd=)(\w+)/g);//(/((?<=\&dd=)(.*?)(?=\&|\#))/g);
                        if (typeof ddVal != "string") {
                            var encodedString = ddVal[0].replace('dd=', '');
                        }
                        else {
                            var encodedString = ddVal.replace('dd=', '');
                        }
                    }
                }
                if (typeof currentDoc.urlFormat != 'undefined') {
                    if (newDocFlag == false) {
                        currentDoc.urlFormat = currentDoc.urlFormat.replace("{}", encodedString);
                        if (currentDoc.docType == 7 || currentDoc.docType == 21)
                        {
                            currentDoc.urlFormat = currentDoc.urlFormat.replace("{}", encodedString);
                        }
                        currentDoc.urlFormat = currentDoc.urlFormat.replace("==", 2);
                    }
                    else
                    {
                        currentDoc.urlFormat = "";
                    }
                }
                if (recentDocs.length > recentDocsHistoryLength) {
                    recentDocs.shift();
                    console.log(recentDocs);
                }

                if (locationStore == persistenceApiService.storeLocation.SessionStorage) {

                    var documentIsExist = false;
                    if (recentDocs.length >= 1) {
                        var previousDoc = recentDocs.length - 1;
                        if (recentDocs[previousDoc].docType == currentDoc.docType) {
                            if (recentDocs[previousDoc].docCode == 0 || (recentDocs[previousDoc].docCode == currentDoc.docCode)) {
                                   var compareDocs = JSON.stringify(recentDocs[previousDoc]) === JSON.stringify(currentDoc)
                                    documentIsExist = true;
                                    if (compareDocs == false) {
                                        angular.extend(recentDocs[previousDoc], currentDoc)
                                    }
                                }
                            }                     
                    }
                    if (documentIsExist == false) {
                        recentDocs.push(currentDoc);
                        if (recentDocs.length > recentDocsHistoryLength) {
                            recentDocs.shift();
                        }
                    }
                    persistenceApiService.saveUserData(locationStore, 0, 'recentDocuments', JSON.stringify(recentDocs));
                }
                else if (locationStore == persistenceApiService.storeLocation.LocalStorage) {
                    if (currentDoc.docCode > 0) {
                        var documentIsExist = false;
                        if (recentDocs.length > 0) {
                            for (var i = recentDocs.length - 1; i >= 0; i--) {
                                if (recentDocs[i].docType == currentDoc.docType) {
                                    if (recentDocs[i].docCode == currentDoc.docCode) {
                                        var compareDocs = JSON.stringify(recentDocs[i]) === JSON.stringify(currentDoc)
                                        documentIsExist = true;
                                        if (compareDocs == false) {
                                            angular.extend(recentDocs[i], currentDoc);
                                        }
                                    }
                                }
                            }
                        }
                        if (documentIsExist == false) {
                            recentDocs.push(currentDoc);
                            if (recentDocs.length > recentDocsHistoryLength) {
                                recentDocs.shift();
                }
                }
                persistenceApiService.saveUserData(locationStore, 0, 'recentDocuments', JSON.stringify(recentDocs));
            }

            }
            }
            else if (locationStore == persistenceApiService.storeLocation.DB) {
                if (typeof currentDoc.dd != 'undefined') {
                    currentDoc.dd = currentDoc.dd.replace("{docCode}", currentDoc.docCode);
                    currentDoc.dd = currentDoc.dd.replace("{bpc}", currentDoc.bpc);
                }
                var encodedString = encode(currentDoc.dd);
                if (typeof currentDoc.urlFormat != 'undefined') {
                    currentDoc.urlFormat = currentDoc.urlFormat.replace("{}", encodedString);
                    if (currentDoc.docType == 7 || currentDoc.docType == 21) {
                        currentDoc.urlFormat = currentDoc.urlFormat.replace("{}", encodedString);
            }
                }
                if (currentDoc.docCode > 0 && currentDoc.docType != -9) {

                    var recentDocuments = {};
                    recentDocuments['recentDocuments'] = [];
                    recentDocuments.recentDocuments.push(currentDoc)


                    persistenceApiService.saveUserData(locationStore, 0, 'recentDocuments', recentDocuments, documentType);
                }

            }


        }

        var saveSelectedSection = function (SectionId) {
            if (docType != -10) {
                var recentDocs = persistenceApiService.getUserData(persistenceApiService.storeLocation.SessionStorage, 0, 'recentDocuments');
                if (typeof recentDocs != 'undefined' && recentDocs != null) {
                    if (typeof recentDocs == 'string') {
                        recentDocs = JSON.parse(recentDocs)
                        if (recentDocs.length > 0) {
                            var lastIndex = recentDocs.length;
                            var recentDoc = recentDocs[lastIndex - 1];
                            recentDoc.selectedSectionId = SectionId;
                            persistenceApiService.saveUserData(persistenceApiService.storeLocation.SessionStorage, 0, 'recentDocuments', JSON.stringify(recentDocs));
                            selectedSectionId = SectionId;
                        }
                    }
                }


            }
        }

        var getSelectedSection = function () {
            if (docType != -10) {
                if (selectedSectionId == '') {
                    var recentDocs = persistenceApiService.getUserData(persistenceApiService.storeLocation.SessionStorage, 0, 'recentDocuments');
                    if (typeof recentDocs != 'undefined' && recentDocs != null) {
                        if (typeof recentDocs == 'string') {
                            recentDocs = JSON.parse(recentDocs)
                            if (recentDocs.length > 0) {
                                var lastIndex = recentDocs.length;
                                // var doc= recentDocs[lastIndex-1];
                                selectedSectionId = recentDocs[lastIndex - 1].selectedSectionId;
                                return selectedSectionId;
                            }
                        }
                    }
                } else {
                    return selectedSectionId;
                }

            }
            else {
                return '';
            }
        }

        //Script to create the base64 encode for the url
        var PADCHAR = '=';

        var ALPHA = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

        function getbyte64(s, i) {
            var idx = ALPHA.indexOf(s.charAt(i));
            if (idx === -1) {
                throw "Cannot decode base64";
            }
            return idx;
        }

        function decode(s) {
            // convert to string
            s = "" + s;
            var pads, i, b10;
            var imax = s.length;
            if (imax === 0) {
                return s;
            }

            if (imax % 4 !== 0) {
                throw "Cannot decode base64";
            }

            pads = 0;
            if (s.charAt(imax - 1) === PADCHAR) {
                pads = 1;
                if (s.charAt(imax - 2) === PADCHAR) {
                    pads = 2;
                }
                // either way, we want to ignore this last block
                imax -= 4;
            }

            var x = [];
            for (i = 0; i < imax; i += 4) {
                b10 = (getbyte64(s, i) << 18) | (getbyte64(s, i + 1) << 12) |
                    (getbyte64(s, i + 2) << 6) | getbyte64(s, i + 3);
                x.push(String.fromCharCode(b10 >> 16, (b10 >> 8) & 0xff, b10 & 0xff));
            }

            switch (pads) {
                case 1:
                    b10 = (getbyte64(s, i) << 18) | (getbyte64(s, i + 1) << 12) | (getbyte64(s, i + 2) << 6);
                    x.push(String.fromCharCode(b10 >> 16, (b10 >> 8) & 0xff));
                    break;
                case 2:
                    b10 = (getbyte64(s, i) << 18) | (getbyte64(s, i + 1) << 12);
                    x.push(String.fromCharCode(b10 >> 16));
                    break;
            }
            return x.join('');
        }

        function getbyte(s, i) {
            var x = s.charCodeAt(i);
            if (x > 255) {
                throw "INVALID_CHARACTER_ERR: DOM Exception 5";
            }
            return x;
        }

        function encode(s) {
            if (arguments.length !== 1) {
                throw "SyntaxError: Not enough arguments";
            }

            var i, b10;
            var x = [];

            // convert to string
            s = "" + s;

            var imax = s.length - s.length % 3;

            if (s.length === 0) {
                return s;
            }
            for (i = 0; i < imax; i += 3) {
                b10 = (getbyte(s, i) << 16) | (getbyte(s, i + 1) << 8) | getbyte(s, i + 2);
                x.push(ALPHA.charAt(b10 >> 18));
                x.push(ALPHA.charAt((b10 >> 12) & 0x3F));
                x.push(ALPHA.charAt((b10 >> 6) & 0x3f));
                x.push(ALPHA.charAt(b10 & 0x3f));
            }
            switch (s.length - imax) {
                case 1:
                    b10 = getbyte(s, i) << 16;
                    x.push(ALPHA.charAt(b10 >> 18) + ALPHA.charAt((b10 >> 12) & 0x3F) +
                        PADCHAR + PADCHAR);
                    break;
                case 2:
                    b10 = (getbyte(s, i) << 16) | (getbyte(s, i + 1) << 8);
                    x.push(ALPHA.charAt(b10 >> 18) + ALPHA.charAt((b10 >> 12) & 0x3F) +
                        ALPHA.charAt((b10 >> 6) & 0x3f) + PADCHAR);
                    break;
            }

            var encodedValue = x.join('');
            var PadsLength = encodedValue.match(/\=/g);
            
            if (typeof PadsLength != 'undefined' && PadsLength != null) {
                encodedValue = encodedValue.substring(0, encodedValue.length - PadsLength.length);
                return encodedValue + PadsLength.length;
            }
            return encodedValue
        }


        var service = {
            redirectToPreviousNode: _redirectToPreviousNode,
            historyIsEmpty: _historyIsEmpty,
            getModelData: getModelData,
            saveRecentDocument: saveRecentDocument,
            docDetails: docDetails,
            saveSelectedSection: saveSelectedSection,
            getSelectedSection: getSelectedSection,
            saveWorkspaceRecentDocument: saveWorkspaceRecentDocument
        }
        return service;
    }





})(angular, window);
